import { gql } from '@apollo/client'

export const COLLISION_DETECTION_QUERY = gql`
  query collisionDetectionQuery($firstname: String!, $lastname: String!, $postalCode: String!) {
    m2CasesByCollisionDetection(
      firstname: $firstname
      lastname: $lastname
      postalCode: $postalCode
    ) {
      id
      comments
      claimNumber
      claimDate
      m2LegalArea {
        id
        title
      }
    }
  }
`
